var dirpaths = require('./lib/paths');

Object.assign(exports, dirpaths)
exports.readFiles = require('./lib/readfiles');
exports.readFilesStream = require('./lib/readfilesstream');



//////////////////
// WEBPACK FOOTER
// ./~/node-dir/index.js
// module id = 99
// module chunks = 0